import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyUpdateCartBuyerIdentity = async (cartId, customer) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
        "Content-Type": "application/json",
      },
      data: {
        query: `
          mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
            cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
              cart {
                id
                buyerIdentity {
                  customer {
                    id
                  }
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `,
        variables: {
          cartId,
          buyerIdentity: {
            email: customer.email,
            countryCode: "US",
          },
        },
      },
    });

    if (response.data.data.cartBuyerIdentityUpdate) {
      return response.data.data.cartBuyerIdentityUpdate;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};

export default ShopifyUpdateCartBuyerIdentity;
